export default {"src":"/_next/static/media/indonesia.e0bd7e6b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};